import * as React from 'react';

export type Section = 'schema' | 'uiSchema' | 'businessRules' | 'advancedSettings' | 'query' | 'projection' | 'pageConfig' | 'content';

interface OwnProps {
  visibleSections: Section[];
  onSectionChanged: (section: Section) => void;
  activeSection: Section;
}

type StepSubMenuProps = OwnProps;

const StepSubMenu = (props: StepSubMenuProps) => {

  const renderSection = (section: Section) => {
    let icon = "home";
    let title = 'home';

    switch (section) {
      case "schema":
        icon = "file code";
        title = "Schema";
        break;
      case "uiSchema":
        icon = 'desktop';
        title = 'UI Schema';
        break;
      case "businessRules":
        icon = 'shield alternate';
        title = 'Business Rules';
        break;
      case "advancedSettings":
        icon = 'sliders horizontal';
        title = 'Advanced Settings';
        break;
      case "query":
        icon = 'sync alternate';
        title = 'Query & Resolver'
        break;
      case 'projection':
        icon = 'video';
        title = 'Projection';
        break;
      case 'pageConfig':
        icon = 'columns';
        title = 'Page Config';
        break;
      case 'content':
        icon = 'object group outline';
        title = 'Content';
        break;
    }

    return <a key={section} title={title} className={`item ${section === props.activeSection ? 'active' : ''}`} onClick={() => props.onSectionChanged(section)}>
      <i className={`${icon} icon`} />
    </a>
  }

  return <div className="ui blue secondary menu" style={{margin: 0, position: "sticky", top: 0, backgroundColor: '#fff', zIndex: 10000}}>
    {props.visibleSections.map(renderSection)}
  </div>
};

export default StepSubMenu;
